// --- React
import React, { useRef } from 'react';
// --- Editor Component
import JoditEditor from 'jodit-react';
// --- Redux
import { useSelector } from 'react-redux';
import { useCommentsActions } from '../../../../../store/comments/useComments';
import { config as baseConfig } from '../../../../../utils/editorConfig';

/**
 * EditorComponent
 *
 * This component is responsible for rendering a rich text editor using JoditEditor.
 * It allows users to edit the body of a comment.
 * It uses Redux to manage the state of the comment being edited.
 *
 * @component
 * @returns {JSX.Element} The rendered EditorComponent with JoditEditor.
 */
export const EditorComponent = ({ isReadOnly }) => {
    const { comment } = useSelector((s) => s.comments);
    const { updateCommentsFilterForm } = useCommentsActions();

    const editor = useRef(null);
    const config = { ...baseConfig, readonly: isReadOnly };
    return (
        <div style={{ width: '100%' }}>
            <br />
            <JoditEditor
                ref={editor}
                value={comment.body}
                config={config}
                tabIndex={1}
                onBlur={(newContent) =>
                    updateCommentsFilterForm({
                        key: 'comment',
                        data: { body: newContent },
                    })
                }
            />
        </div>
    );
};
